import axios from "axios";

export const getQrMenuSettings = () => {
  return axios.get("/api/1.0/qr-menu-settings");
};

export const updateQrMenuSettings = (body) => {
  return axios.put("/api/1.0/qr-menu-settings", body);
};
